import type { LucideIcon } from 'lucide-react';
import {
  BarChart3,
  Building2,
  ClipboardList,
  Drama,
  Factory,
  GraduationCap,
  HardHat,
  Hospital,
  Landmark,
  Microscope,
  Package,
  Pickaxe,
  Radio,
  ShoppingCart,
  Truck,
  UtensilsCrossed,
  Wheat,
  Wrench,
  Zap,
} from 'lucide-react';

/** NAICS 2-digit sector → Lucide icon */
export const INDUSTRY_ICONS: Record<string, LucideIcon> = {
  '11': Wheat,
  '21': Pickaxe,
  '22': Zap,
  '23': HardHat,
  '31': Factory,
  '42': Package,
  '44': ShoppingCart,
  '48': Truck,
  '51': Radio,
  '52': Landmark,
  '53': Building2,
  '54': Microscope,
  '55': BarChart3,
  '56': ClipboardList,
  '61': GraduationCap,
  '62': Hospital,
  '71': Drama,
  '72': UtensilsCrossed,
  '81': Wrench,
  '92': Landmark,
};

export function getIndustryIcon(naicsCode: string): LucideIcon {
  return INDUSTRY_ICONS[naicsCode] ?? Building2;
}
